import { useTranslation } from 'react-i18next';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';

import Separator from '../../../../../../components/Separator/Separator';
import PrioritiseDragCheckboxList from './PrioritiseDragCheckboxList';
import PrioritiseSubTopicCheckboxList from './PrioritiseSubTopicCheckboxList';
import PrioritiseTopicCheckboxList from './PrioritiseTopicCheckboxList';

import type { ISurveyAnswerPrioritiseTopicProps } from '../interfaces/ISurveyAnswerPrioritiseTopic';

import styles from './scss/SurveyAnswerPrioritiseTopics.module.scss';

function PrioritiseTopics({
  control,
  standardTopicsData,
  currentStep,
}: ISurveyAnswerPrioritiseTopicProps) {
  const { t } = useTranslation();

  const getStepConfig = () => {
    if (!standardTopicsData || standardTopicsData.length === 0) {
      return {
        title: t('materialityAssessment.selectTheMostImportant'),
        description: t('materialityAssessment.selectTheMostImportantDescribe'),
        renderElement: null,
      };
    }

    switch (currentStep) {
      case 2:
        return {
          title: t('materialityAssessment.selectTheMostImportantSub'),
          description: t('materialityAssessment.selectTheMostImportantDescribe'),
          renderElement: <PrioritiseSubTopicCheckboxList control={control} standardTopicsData={standardTopicsData} />,
        };
      case 3:
        return {
          title: t('materialityAssessment.prioritiseYourTop10Topics'),
          description: t('materialityAssessment.clickAndDragTheTopic'),
          renderElement: <PrioritiseDragCheckboxList control={control} standardTopicsData={standardTopicsData} />,
        };
      default:
        return {
          title: t('materialityAssessment.selectTheMostImportant'),
          description: t('materialityAssessment.selectTheMostImportantDescribe'),
          renderElement: <PrioritiseTopicCheckboxList control={control} standardTopicsData={standardTopicsData} />,
        };
    }
  };

  const { title, description, renderElement } = getStepConfig();

  return (
    <div className={styles.container}>
      <TitleWrapper
        title={title}
        description={description}
      />
      {renderElement}
      <Separator />
    </div>
  );
}

export default PrioritiseTopics;
